
export function ConvertToLocalTime(isoString: string): React.ReactNode {
    const language = localStorage.getItem("i18nextLng") || "en";
    const localDate = new Date(isoString);
    const localTimeString = localDate.toLocaleString(language, {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
    });
    
    return localTimeString;
}